import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import groupBy from 'lodash/groupBy';
import { Spin } from 'antd';

import { queryCities } from './gql';

import CityItem from './components/city-item';

export default function Strategy() {
  const { t } = useTranslation();
  const [cities, setCities] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const cityList = useMemo(
    () => groupBy(cities, key => key?.node?.originalName?.charAt(0)),
    [cities],
  );
  const firstLetterArr = Object.keys(cityList).sort();

  const [queryAllCities, { loading }] = useLazyQuery(queryCities, {
    fetchPolicy: 'no-cache',
    onCompleted: data => {
      if (data?.getActiveCities) {
        setTotalCount(data.getActiveCities.totalCount);
        setCities(data.getActiveCities.edges);
      }
    },
  });

  useEffect(() => {
    queryAllCities();
  }, []);

  if (loading) {
    return <Spin className="strategy-loading" />;
  }

  return (
    <div className="strategy-container">
      <header className="title">{t('cms.dashboard.strategy.header.title')}</header>
      <section className="destination-wrapper">
        <span className="total-count">
          {t('cms.dashboard.strategy.city_list.total', { count: totalCount })}
        </span>
        <div className="city-list-wrapper">
          {firstLetterArr?.map((item, index) => (
            <CityItem key={index} firstLetter={item?.toUpperCase()} cityData={cityList[item]} />
          ))}
        </div>
      </section>
    </div>
  );
}
